import { Component, OnInit, Injector } from '@angular/core';
import { SecondPageEditBase } from 'vnpost-shared';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { SaleRecordService } from '../../services/sale-record.service';
import { CategoryService } from '../../services/category.service';
import { ProductService } from '../../services/product.service';
import { SaleAssociateService } from '../../services/sale-associate.service';

@Component({
  selector: 'app-sale-record-edit',
  templateUrl: './sale-record-edit.component.html',
  styleUrls: ['./sale-record-edit.component.css'],
})
export class SaleRecordEditComponent
  extends SecondPageEditBase
  implements OnInit
{
  listCategory: { label: string; value: string }[] = []; //[{label: "Bảo hiểm xã hội", value: "demoTyppeService"}];
  listProduct: { label: string; value: string }[] = [];
  listEthnic: { label: string; value: string }[] = [
    { label: 'Kinh', value: '1' },
    { label: 'Khác', value: '2' },
  ];
  listUser: { label: string; value: string }[] = []; //[{label: "Nguyễn Văn Abc", value: "abc.bc"}];
  listGender: { label: string; value: string }[] = [
    { label: 'Nam', value: 'male' },
    { label: 'Nữ', value: 'female' },
  ];
  unitCode = this.currentUser.unitCode;
  disable: boolean = false;

  constructor(
    protected _saleRecordService: SaleRecordService,
    protected _categoryService: CategoryService,
    protected _productService: ProductService,
    protected _injector: Injector,
    protected _saleAssociateService: SaleAssociateService,
  ) {
    super(_saleRecordService, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl({ disable: true }, [Validators.required]),
      contractCode: new UntypedFormControl('', [Validators.required]),
      categoryId: new UntypedFormControl('', [Validators.required]),
      startDate: new UntypedFormControl('', [Validators.required]),
      productId: new UntypedFormControl('', [Validators.required]),
      endDate: new UntypedFormControl('', [Validators.required]),
      nameUser: new UntypedFormControl('', [Validators.required]),
      birthDay: new UntypedFormControl('', [Validators.required]),
      gender: new UntypedFormControl(''),
      phone: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(/^0\d{8,11}$/),
      ]),
      ethnic: new UntypedFormControl(''),
      citizenId: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(/^\d{9,12}$/),
      ]),
      dateRange: new UntypedFormControl(''),
      issuedBy: new UntypedFormControl(''),
      address: new UntypedFormControl(''),
      salesNumber: new UntypedFormControl('', [Validators.required]),
      revenue: new UntypedFormControl({ disable: true }),
      totalRemuneration: new UntypedFormControl({ disable: true }),
      remunerationReceived: new UntypedFormControl({ disable: true }),
      adjust: new UntypedFormControl(''),
      userCode: new UntypedFormControl(''),
      actuallyReceived: new UntypedFormControl(''),
    });
  }

  ngOnInit() {}

  onShowPopup(model: any) {
    this.disable = model.isDisable;
    if (this.listUser.length == 0) {
      this.getListUser();
    }
    if (this.listCategory.length == 0) {
      this.getListService();
    }
    this.validationSummary.resetErrorMessages();
    this.resetForm();

    if (model.code) {
      this._saleRecordService.getSaleRecord(model.code).then(
        async (rs) => {
          this.itemDetail = rs.data;
          if (this.itemDetail.startDate)
            this.itemDetail.startDate = new Date(this.itemDetail.startDate);
          if (this.itemDetail.endDate)
            this.itemDetail.endDate = new Date(this.itemDetail.endDate);
          if (this.itemDetail.birthDay)
            this.itemDetail.birthDay = new Date(this.itemDetail.birthDay);
          if (this.itemDetail.dateRange)
            this.itemDetail.dateRange = new Date(this.itemDetail.dateRange);
          this.getListProduct();
        },
        (error) => {
          this._notifierService.showWarning(
            this._translateService.instant('MESSAGE.NOT_FOUND_ERROR')
          );
        }
      );
    }
  }
  getListProduct() {
    if (this.itemDetail.categoryId) {
      const model = {
        categoryId: this.itemDetail.categoryId,
        status: 1,
      };
      this._productService.getListProduct(model).then(
        (res) => {
          this.listProduct = res?.data.map((x) => ({
            label: `${x.code} - ${x.name}`,
            value: x.id,
          }));
        },
        (err) => {
          this.listProduct = [];
        }
      );
    }
  }

  getListService() {
    const model = {
      status: 1
    };
    this._categoryService.getListCategory(model).then(
      (res) => {
        this.listCategory = res?.data.map((x) => ({
          label: `${x.code} - ${x.name}`,
          value: x.id,
        }));
      },
      (err) => {
        this.listCategory = [];
      }
    );
  }

  getListUser() {
    var model = {
      search: '',
      status: 1,
      unitCode: this.unitCode
    };
    this._saleAssociateService.getListSalesAssociate(model).then(
      (response) => {
        this.listUser = response.data.map((user) => ({
          label: `${user.displayName} (${user.salesAssociateCode ?? ''})`,
          value: user.salesAssociateCode,
        }));
      },
      (error) => {
        this.listUser = [];
        // this._notifierService.showError("Không tính được doanh thu");
      }
    );
  }

  onEnterSaleNumber() {
    if (this.itemDetail.salesNumber && this.itemDetail.productId) {
      var model = {
        salesNumber: this.itemDetail.salesNumber,
        productId: this.itemDetail.productId,
        unitCode: this.currentUser.unitCode
      }
      this._saleRecordService
        .getRevenue(model)
        .then(
          (res) => {
            this.itemDetail.revenue = res?.data?.revenue;
            this.itemDetail.totalRemuneration = res?.data?.totalRemuneration;
            this.itemDetail.remunerationReceived =
              res?.data?.remunerationReceived;
          },
          (error) => {
            if (error?.error?.message) 
              this._notifierService.showError(error?.error?.message);
            else this._notifierService.showError('Không tính được doanh thu');
          }
        );
    }
  }

  async save() {
    this.submitting = true;

    if (this.formGroup.invalid) {
      this.submitting = false;
      this.validationSummary.showValidationSummary();
      return;
    }

    this.onUpdate();
  }

  onUpdate() {
    var model = Object.assign({...this.itemDetail}, {
      startDate: `${this.itemDetail.startDate.getFullYear()}-${(this.itemDetail.startDate.getMonth() + 1).toString().padStart(2, '0')}-${this.itemDetail.startDate.getDate().toString().padStart(2, '0')}`,
      endDate: `${this.itemDetail.endDate.getFullYear()}-${(this.itemDetail.endDate.getMonth() + 1).toString().padStart(2, '0')}-${this.itemDetail.endDate.getDate().toString().padStart(2, '0')}`,
      birthDay: `${this.itemDetail.birthDay.getFullYear()}-${(this.itemDetail.birthDay.getMonth() + 1).toString().padStart(2, '0')}-${this.itemDetail.birthDay.getDate().toString().padStart(2, '0')}`,
      dateRange: this.itemDetail.dateRange ? `${this.itemDetail.dateRange.getFullYear()}-${(this.itemDetail.dateRange.getMonth() + 1).toString().padStart(2, '0')}-${this.itemDetail.dateRange.getDate().toString().padStart(2, '0')}` : null,
    })

    this._saleRecordService.update(this.itemDetail.code, model).then(
      (response) => {
        this.closePopupMethod(true);
        this._notifierService.showUpdateDataSuccess();
        this.onAfterSave();
        this.submitting = false;
      },
      (error) => {
        if (error?.error?.message) 
          this._notifierService.showError(error?.error?.message);
        else this._notifierService.showUpdateDataFailed();
        this.submitting = false;
      }
    );
  }
}
